/* --------------------------------------------------------------------------------------
   gradeTests.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

import scanComponent from './components/scan.component'
import scanCtrl from './components/scan.controller'
import { scanService } from './services/scan.service'

const gradeTestsComponent =  {
  template: require('./gradeTests.html'),
  controller: 'gradeTestsCtrl',
  controllerAs: 'vm'
}

class gradeTestsCtrl {
  constructor ($state) {
    this.$state = $state
  }
  $onInit () {
    $('body').removeClass('xrx-background navy')
    this.step = 0;
  }
  back() {
    this.step--
    if (this.step < 0)
      this.$state.go('main')
  }
  next () {
    this.step++
    if (this.step > 2)
      this.$state.go('main')
  }
}

export const appGradeTestsModule = angular.module('app.gradeTests', ['ui.router','app.common'])
  .component('gradeTests', gradeTestsComponent)
  .controller('gradeTestsCtrl', gradeTestsCtrl)
  .component('scan', scanComponent)
  .controller('scanCtrl', scanCtrl)
  .service('scanService', scanService)



// WEBPACK FOOTER //
// ./src/app/gradeTests/gradeTests.js